import React, { useState, useEffect } from 'react';

function CariSopirdo({ onSelect, onCancel }) {
  const [sopirList, setSopirList] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [filteredSopir, setFilteredSopir] = useState([]);
  const schema = localStorage.getItem('schema');
  
  useEffect(() => {
    const fetchSopir = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/utama.php?caller=sopir_do&schema=${schema}`);
        const data = await response.json();
        setSopirList(data);
        setFilteredSopir(data);
      } catch (error) {
        console.error('Error fetching sopir:', error);
      }
    };

    fetchSopir();
  }, []);

  useEffect(() => {
    const filtered = sopirList.filter((sopir) =>
      sopir.SOPIR.toLowerCase().includes(searchTerm.toLowerCase())
    );
    setFilteredSopir(filtered);
  }, [searchTerm, sopirList]);

  return (
    <div
      style={{
        width: '90%',
        maxWidth: '1100px',
        margin: 'auto',
        padding: '20px',
        border: '1px solid #ccc',
        borderRadius: '8px',
        backgroundColor: '#ffffff',
        boxShadow: '0 0 10px rgba(0,0,0,0.1)',
        overflowX: 'auto',
      }}
    >
      <h2 style={{ marginBottom: '15px' }}>Cari Sopir</h2>

      <div style={{ marginBottom: '15px' }}>
        <input
          type="text"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          placeholder="Masukkan nama sopir"
          style={{
            width: '100%',
            padding: '8px',
            marginTop: '5px',
            borderRadius: '5px',
            border: '1px solid #ccc',
          }}
        />
      </div>

      <div style={{ overflowX: 'auto' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse', marginBottom: '15px' }}>
          <thead style={{ backgroundColor: '#f0f0f0' }}>
            <tr>
              <th style={{ ...thStyle, textAlign: 'center' }}>Aksi</th>                
              <th style={thStyle}>Sopir</th>
              <th style={thStyle}>Tgl DO</th>
              <th style={thStyle}>No DO</th>
              <th style={thStyle}>Kd Kendaraan</th>
              <th style={thStyle}>Nopol</th>
              <th style={thStyle}>Asal</th>
              <th style={thStyle}>Tujuan</th>
              <th style={thStyle}>Norek</th>
            </tr>
          </thead>
          <tbody>
            {filteredSopir.map((sopir, index) => (
              <tr key={index}>
                <td style={{ ...tdStyle, textAlign: 'center' }}>
                  <button
                    onClick={() => onSelect(sopir)}
                    style={{
                      padding: '6px 12px',
                      backgroundColor: '#4CAF50',
                      color: 'white',
                      border: 'none',
                      borderRadius: '5px',
                      cursor: 'pointer',
                    }}
                  >
                    Pilih
                  </button>
                </td>                
                <td style={tdStyle}>{sopir.SOPIR}</td>
                <td style={tdStyle}>{sopir.TGL_TRANSAKSI}</td>
                <td style={tdStyle}>{sopir.NO_TRANSAKSI}</td>
                <td style={tdStyle}>{sopir.KD_KENDARAAN}</td>
                <td style={tdStyle}>{sopir.NOPOL}</td>
                <td style={tdStyle}>{sopir.KOTA_ASAL}</td>
                <td style={tdStyle}>{sopir.KOTA_TUJUAN}</td>
                <td style={tdStyle}>{sopir.NOREK}</td>    
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div style={{ textAlign: 'center' }}>
        <button
          onClick={onCancel}
          style={{
            padding: '10px 15px',
            backgroundColor: '#f44336',
            color: 'white',
            border: 'none',
            borderRadius: '5px',
            cursor: 'pointer',
          }}
        >
          Batal
        </button>
      </div>
    </div>
  );
}

const thStyle = {
  padding: '10px',
  border: '1px solid #ddd',
  fontWeight: 'bold',
  minWidth: '100px',
};

const tdStyle = {
  padding: '8px',
  border: '1px solid #ddd',
};

export default CariSopirdo;
